<template>
  <div class="dados-privados-details">
    <page-header :title="title" />
    <div class="container">
      <page-section
        v-for="(item, i) in Object.keys(fields)"
        :group-label="$t(item)"
        :key="item + '_' + i"
      >
        <v-layout wrap>
          <div
            class="mb-4 mr-1"
            v-for="(subitem, i) in fields[item]"
            :key="'sub_' + item + '_' + i"
          >
            {{ setCheckedField(item, i) }}
            <v-chip
              small
              class="py-6"
              v-if="subitem.value"
              color="transparent"
              text-color="deep-orange lighten-2"
              dark
              @click="() => showFormWithSelectedRestrictFields(item)"
            >
              <v-layout column>
                <v-layout align-center>
                  <v-icon class="mr-1">mdi-lock</v-icon>
                  <small>{{ $t("restrito") }}</small>
                </v-layout>
                <v-layout style="margin-left: 2px">
                  {{ subitem.label }}
                </v-layout>
              </v-layout>
            </v-chip>
            <v-chip
              v-else
              small
              class="py-6"
              color="transparent"
              text-color="blue lighten-0"
              dark
              @click="() => showFormWithSelectedRestrictFields(item)"
            >
              <v-layout column>
                <v-layout align-center>
                  <v-icon class="mr-1">mdi-earth</v-icon>
                  <small>{{ $t("publico") }}</small>
                </v-layout>
                <v-layout style="margin-left: 2px">
                  {{ subitem.label }}
                </v-layout>
              </v-layout>
            </v-chip>
          </div>
        </v-layout>
      </page-section>
      <Form :title="title" :data="fields" :selected="getFields" />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import Form from "./form";
import i18next from "i18next";

const fields = () => ({
  Perfil: [
    { id: 1, key: "fotoPerfil", label: i18next.t("Foto"), value: false },
  ],
  Dados_Pet: [
    { id: 1, key: "nome", label: i18next.t("Nome_Completo"), value: false },
    { id: 2, key: "especie", label: i18next.t("Especie"), value: false },
    { id: 3, key: "raca", label: i18next.t("Raca"), value: false },
    { id: 4, key: "sexo", label: i18next.t("Sexo"), value: false },
    { id: 5, key: "idade", label: i18next.t("Idade"), value: false },
    { id: 6, key: "chip", label: i18next.t("Chip"), value: false },
    { id: 7, key: "rga", label: i18next.t("Rga"), value: false },
    { id: 8, key: "statusPet", label: i18next.t("Status_Pet"), value: false },
  ],
  Dono_Cuidador: [
    { id: 1, key: "nomeDono", label: i18next.t("Nome_Dono"), value: false },
    {
      id: 2,
      key: "nomeCuidador",
      label: i18next.t("Nome_Cuidador"),
      value: false,
    },
    { id: 3, key: "foneDono", label: i18next.t("Telefone_Dono"), value: false },
    { id: 4, key: "cep", label: i18next.t("CEP"), value: false },
    {
      id: 5,
      key: "foneCuidador",
      label: i18next.t("Telefone_Cuidador"),
      value: false,
    },
  ],
  Dados_Fisicos: [
    { id: 1, key: "castrado", label: i18next.t("Castrado"), value: false },
    { id: 2, key: "pedigree", label: i18next.t("Pedigree"), value: false },
  ],
  Dados_Alimentacao: [
    { id: 1, key: "tipoRacao", label: i18next.t("Racao"), value: false },
    { id: 2, key: "marcaRacao", label: i18next.t("Marca"), value: false },
  ],
  Medicamentos: [
    {
      id: 1,
      key: "medicamentos",
      label: i18next.t("Medicamentos"),
      value: false,
    },
  ],
  Doencas: [
    { id: 1, key: "doencas", label: i18next.t("Doencas"), value: false },
  ],
  Alergias: [
    {
      id: 1,
      key: "alergiaAlimentar",
      label: i18next.t("Alergia_Alimentos"),
      value: false,
    },
    {
      id: 2,
      key: "alergiaMedicamento",
      label: i18next.t("Alergia_Medicamentos"),
      value: false,
    },
    {
      id: 3,
      key: "alergiaOutros",
      label: i18next.t("Outras_Alergias"),
      value: false,
    },
  ],
  Cart_Vacinacao: [
    {
      id: 1,
      key: "carteiraVacinacao",
      label: i18next.t("Carteira_Vacinacao"),
      value: false,
    },
    {
      id: 2,
      key: "carteiraConvenio",
      label: i18next.t("Carteira_Convenio"),
      value: false,
    },
    {
      id: 3,
      key: "carteiraDoador",
      label: i18next.t("Carteira_Doador"),
      value: false,
    },
    {
      id: 4,
      key: "carteiraLink",
      label: i18next.t("Carteira_Link"),
      value: false,
    },
  ],
  Prontuario_Medico: [
    {
      id: 1,
      key: "prontuarioMedico",
      label: i18next.t("Prontuario_Medico"),
      value: false,
    },
  ],
  Veterinario: [
    {
      id: 1,
      key: "nomeVeterinario",
      label: i18next.t("Veterinario"),
      value: false,
    },
    {
      id: 2,
      key: "foneVeterinario",
      label: i18next.t("Telefone_Clinica"),
      value: false,
    },
    {
      id: 3,
      key: "empresaVeterinario",
      label: i18next.t("Clinica"),
      value: false,
    },
    { id: 4, key: "observacao", label: i18next.t("Observacao"), value: false },
  ],
  Outras_Informacoes: [
    {
      id: 1,
      key: "informacoes",
      label: i18next.t("Outras_Informacoes"),
      value: false,
    },
  ],
});

export default {
  metaInfo: {
    titleTemplate: (i18next.t("Dados_Privados") || "") + " | %s",
  },
  components: { PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Dados_Privados"),
    fields: { ...fields() },
    select: "",
  }),
  computed: {
    pet() {
      return this.$store.state.pet.data || {};
    },
    getFields() {
      const select = this.$store.state.selectedRestrictFields;
      return select ? { [select]: this.fields[select] } : this.fields;
    },
  },
  mounted() {
    // lazy load em caso de recarregamento da página para aguardar as traduções serem carregadas
    setTimeout(() => {
      this.title = i18next.t("Dados_Privados");
      if (!document.title.includes(this.title))
        document.title = this.title + " " + document.title;
      this.fields = fields();
    }, 400);
  },
  methods: {
    setCheckedField(group, fieldIndex) {
      this.fields[group][fieldIndex].value =
        this.pet &&
        this.pet.camposRestritos &&
        this.pet.camposRestritos
          .split(",")
          .some((e) => e === this.fields[group][fieldIndex].key);
    },
    showFormWithSelectedRestrictFields(field) {
      this.$store.commit("setSelectedRestrictFields", field);
      this.$store.commit("setShowModalDataForm", true);
    },
  },
};
</script>

<style lang="scss">
.dados-privados-details {
  .container {
    padding: 0;
    margin: 0;
  }

  @media (min-width: 1025px) {
    .container {
      overflow: hidden auto;
      height: 580px;
      min-height: 580px;
      max-height: 580px;
    }
  }
}
</style>
